import { atom, useAtom } from "jotai";

const headerAtom = atom({
  isHamburgerDropdownOpen: false,
  isCategoryDropdownOpen: false,
  selectedCategoryIndex: -1,
  isMobileHamburgerOpen: false
});

const actions = {
  openHamburgerDropdown: () => ({
    ...initialState,
    isHamburgerDropdownOpen: true
  }),
  closeHamburgerDropdown: (state: typeof initialState) => ({
    ...state,
    isHamburgerDropdownOpen: false
  }),
  openCategoryDropdown: () => ({
    ...initialState,
    isCategoryDropdownOpen: true
  }),
  closeCategoryDropdown: (state: typeof initialState) => ({
    ...state,
    isCategoryDropdownOpen: false
  }),
  setSelectedCategoryIndex: (state: typeof initialState, payload: number) => ({
    ...state,
    selectedCategoryIndex: payload
  }),
  openMobileHamburger: () => ({
    ...initialState,
    isMobileHamburgerOpen: true
  }),
  closeMobileHamburger: (state: typeof initialState) => ({
    ...state,
    isMobileHamburgerOpen: false
  }),
  resetAll: () => ({
    ...initialState
  })
};

const initialState = {
  isHamburgerDropdownOpen: false,
  isCategoryDropdownOpen: false,
  selectedCategoryIndex: -1,
  isMobileHamburgerOpen: false
};

type HeaderAction =
  | { type: "openHamburgerDropdown" }
  | { type: "closeHamburgerDropdown" }
  | { type: "openCategoryDropdown" }
  | { type: "closeCategoryDropdown" }
  | { type: "setSelectedCategoryIndex"; payload: number }
  | { type: "openMobileHamburger" }
  | { type: "closeMobileHamburger" }
  | { type: "resetAll" };

export const headerActionsAtom = atom(
  null,
  (get, set, action: HeaderAction) => {
    const state = get(headerAtom);

    const dispatcher: {
      [K in HeaderAction["type"]]: (
        state: typeof initialState,
        action: Extract<HeaderAction, { type: K }>
      ) => typeof initialState;
    } = {
      openHamburgerDropdown: () => actions.openHamburgerDropdown(),
      closeHamburgerDropdown: state => actions.closeHamburgerDropdown(state),
      openCategoryDropdown: () => actions.openCategoryDropdown(),
      closeCategoryDropdown: state => actions.closeCategoryDropdown(state),
      setSelectedCategoryIndex: (state, action) =>
        actions.setSelectedCategoryIndex(state, action.payload),
      openMobileHamburger: () => actions.openMobileHamburger(),
      closeMobileHamburger: state => actions.closeMobileHamburger(state),
      resetAll: () => actions.resetAll()
    };

    const handler = dispatcher[action.type] as any;
    if (handler) {
      set(headerAtom, handler(state, action));
    }
  }
);

export const useHeaderAtom = () => {
  const [state] = useAtom(headerAtom);
  const [, setAction] = useAtom(headerActionsAtom);

  return {
    state,
    openHamburgerDropdown: () => setAction({ type: "openHamburgerDropdown" }),
    closeHamburgerDropdown: () => setAction({ type: "closeHamburgerDropdown" }),
    openCategoryDropdown: () => setAction({ type: "openCategoryDropdown" }),
    closeCategoryDropdown: () => setAction({ type: "closeCategoryDropdown" }),
    setSelectedCategoryIndex: (index: number) =>
      setAction({ type: "setSelectedCategoryIndex", payload: index }),
    openMobileHamburger: () => setAction({ type: "openMobileHamburger" }),
    closeMobileHamburger: () => setAction({ type: "closeMobileHamburger" }),
    resetAll: () => setAction({ type: "resetAll" })
  };
};
